import { useContext, useEffect } from 'react';

import { LoadSavedQuotationsCard, QuotationInfoContext } from '../../../shared';

import { LOADING_SAVED_QUOTATIONS_STATES } from '../../../shared/interfaces/loading-saved-quotations-states-enum';

import './index.css';

export const LoadSavedQuotation = () => {
  const { setLoadSaveQuotationState } = useContext(QuotationInfoContext);

  useEffect(() => {
    setLoadSaveQuotationState(LOADING_SAVED_QUOTATIONS_STATES.INIT_LOADING);
  }, []);

  return <LoadSavedQuotationsCard />;
};
